export class UserService {
    serviceConfig;
    fetchClient;
    constructor(fetchClient, serviceConfiguration) {
        this.serviceConfig = serviceConfiguration;
        this.fetchClient = fetchClient;
    }
    processUserRequest(request) {
        const userMetadata = request.metadata;
        userMetadata.hasOnboarded = userMetadata.hasOnboarded === undefined ? [] : userMetadata.hasOnboarded;
        return {
            ...request,
            metadata: userMetadata,
        };
    }
    getCurrentLoggedInUserDetails = async () => {
        const request = this.fetchClient.getJson(`${this.serviceConfig.authServiceApiRoot}/user/me`);
        const response = await request.response;
        return this.processUserRequest(response);
    };
    updateOnboarding = async (HasOnboarded) => {
        const request = this.fetchClient.postJson(`${this.serviceConfig.authServiceApiRoot}/user/me/onboarding`, {
            HasOnboarded,
        });
        const response = await request.response;
        return this.processUserRequest(response);
    };
    loginToAuthService = async () => {
        const request = this.fetchClient.post(`${this.serviceConfig.authServiceApiRoot}/auth/loginWithToken`, '{}', {
            credentials: 'include',
        });
        const response = await request.response;
        if (response.status >= 200 && response.status < 300) {
            return true;
        }
        else {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
    };
    redirectToAuthServiceLogout = (idToken) => {
        const url = this.getAuthServiceLogoutUrl(idToken);
        window.location.href = url.toString();
    };
    getAuthServiceLogoutUrl(idToken) {
        const url = new URL(`${this.serviceConfig.authServiceApiRoot}/oauth2/logout`);
        url.searchParams.append('post_logout_redirect_uri', `${window.location.protocol}//${window.location.host}/`);
        if (idToken) {
            url.searchParams.append('id_token_hint', idToken);
        }
        return url;
    }
}
//# sourceMappingURL=UserService.js.map